var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20138 0.549805C3.89395 0.549805 0.432617 4.28736 0.432617 8.94182C0.432617 13.5948 8.20138 24.962 8.20138 24.962C8.20138 24.962 15.9701 13.5948 15.9701 8.94182C15.9701 4.28736 12.5088 0.549805 8.20138 0.549805ZM8.20138 12.7552C6.22444 12.7552 4.66988 11.0774 4.66988 8.94036C4.66988 6.80482 6.22309 5.12554 8.20138 5.12554C10.1783 5.12554 11.7329 6.80336 11.7329 8.94036C11.7329 11.0773 10.1783 12.7552 8.20138 12.7552Z",
    fill: "#5B2029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapMarker);
export default __webpack_public_path__ + "static/media/GoogleMapMarker.7f1e6d14be18125fe5c38a9ff7190704.svg";
export { ForwardRef as ReactComponent };